/**
 * Encounter Facade
 *
 * Stable API surface for encounter operations.
 * @agentic connections
 */

import type { MedplumClient } from "@medplum/core";
import type { Encounter } from "@medplum/fhirtypes";
import {
  upsertEncounterWithPatientTags,
  type UpsertEncounterOptions,
} from "@benchmark/core/actions";
import { CONFIG } from "@/app/config";

/**
 * Creates an Encounter facade instance bound to a MedplumClient.
 * @agentic connections
 */
export function createEncounterFacade(medplum: MedplumClient) {
  return {
    /**
     * Upsert an encounter with related resources, clinical impressions, flags, tasks, and patient tags.
     * @agentic connections
     */
    upsert: (
      options: Omit<UpsertEncounterOptions, "medplum">,
    ): Promise<Encounter> => {
      return upsertEncounterWithPatientTags({
        benchmarkOrganizationId: CONFIG.VITE_BENCHMARK_ORGANIZATION_ID,
        medplum,
        ...options,
      });
    },
  };
}
